const CHUNK_RELOAD_KEY = 'launchpad-admin-chunk-reload'

const CHUNK_ERROR_PATTERNS = [
  /failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /importing a module script failed/i,
  /expected a javascript-or-wasm module script/i,
]

export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error)
  return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(message))
}

/**
 * Cloudflare Pages 发布会原子切换当前产物，但已经打开的 SPA 仍可能持有上一版入口。
 * 用户随后进入一个尚未加载过的懒路由时，旧 chunk 已不存在，动态 import 会失败。
 *
 * 同一个错误签名只自动刷新一次，避免 CDN 或网络持续异常时陷入刷新循环。
 */
export function recoverChunkLoad(
  error: unknown,
  storage: Pick<Storage, 'getItem' | 'setItem'> = window.sessionStorage,
  reload: () => void = () => window.location.reload(),
): boolean {
  if (!isChunkLoadError(error)) return false

  const signature = error instanceof Error ? error.message : String(error)
  try {
    if (storage.getItem(CHUNK_RELOAD_KEY) === signature) return false
    storage.setItem(CHUNK_RELOAD_KEY, signature)
  } catch {
    // 隐私模式下 sessionStorage 可能不可用；此时保留错误页上的手动整页刷新。
    return false
  }
  reload()
  return true
}
